const AdminUIDashboard = () => {
  return <div>AdminUIDashboard</div>
}

export default AdminUIDashboard
